import { Expose } from "class-transformer";
import { CmsProductGeographicalZoneEnum } from "../../enums/cms-product-geographical-zone.enum";
import { ICmsProductGeographicalAreaDto } from "./cms-product-geographical-area.dto.interface";

export class CmsProductGeographicalAreaEntityDto {
  @Expose()
  value!: string;

  @Expose()
  name!: string;
}

export class CmsProductGeographicalAreaDto implements ICmsProductGeographicalAreaDto {
  @Expose()
  geographicalZone!: CmsProductGeographicalZoneEnum;

  @Expose()
  provinces!: CmsProductGeographicalAreaEntityDto[];

  @Expose()
  regions!: CmsProductGeographicalAreaEntityDto[];

  @Expose()
  municipalities!: CmsProductGeographicalAreaEntityDto[];
}
